/* eslint-disable max-lines */
import { Button, Grid, Switch } from '@material-ui/core';
import Drawer from '@material-ui/core/Drawer/Drawer';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import ProductQuickView from 'components/Shared/ProductQuickView';
import Snackbar from 'components/Shared/Snackbar';
import { SvgIcon } from 'components/Shared/SvgIcon';
import { WithStyles } from 'decorators/withStyles';
import { IProductNew } from 'interfaces/product';
import { enChat, IChat } from 'interfaces/script';
import React, { Component } from 'react';
import * as rxjsOperators from 'rxjs-operators';
import { chatService } from 'services/chatService';
import { productNewService } from 'services/productNewService';
import FieldText from 'components/Shared/Field/Text';
import FieldSelect from 'components/Shared/Field/Select';
import PhoneInput from 'react-phone-input-2';
import '../../../../../assets/material-input-phone.css';
import AlertCircleIcon from 'mdi-react/AlertCircleIcon';
import storageService from 'services/storage';
import PopUp from 'components/Shared/PopUp';
import { analyticsG4, enFeatures } from 'services/AnalyticsG4';
import { combineLatest } from 'rxjs';

interface IState {
  selectedProductChat: IProductNew;
  chat: IChat;
  viewedNewRelease: boolean;
}

interface IProps {
  classes?: any;
}

@WithStyles(theme => ({
  '@keyframes toLeft': {
    from: {
      transform: 'translate(448px)'
    },
    to: {
      transform: 'translate(0)'
    }
  },
  drawerPaper: {
    transform: 'translate(448px)',
    animation: 'toLeft 0.3s ease-in-out 0.5s forwards',
    fontFamily: 'Lato',
    width: '448px',
    '@media screen and (max-width: 960px)': {
      width: '100%'
    }
  },
  drawerOptions: {
    overflow: 'auto',
    backgroundColor: '#fff',
    height: '100%',
    padding: 20,
    width: '100%',
    '&::-webkit-scrollbar': {
      width: '6px',
      backgroundColor: '#F5F5F5'
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#555',
      borderRadius: 10
    }
  },
  titleClose: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  h2: {
    fontWeight: 'bold',
    color: theme.variables.colors['primaryColor'],
    margin: 0
  },
  label: {
    fontWeight: 'bold',
    color: '#596375',
    fontSize: '14px',
    margin: '5px 0'
  },
  closeButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '0px solid #000',
    borderRadius: '100%',
    width: 40,
    height: 40,
    color: '#596375',
    fontWeight: 'bold',
    backgroundColor: '#D8D8D8',
    cursor: 'pointer',
    alignSelf: 'flex-start',
    '&:hover': {
      backgroundColor: '#ccc'
    },
    '& svg': {
      width: '30%',
      fontWeight: 'bold',
      fill: '#596375'
    }
  },
  button: {
    fontWeight: 400,
    backgroundColor: '#009358',
    color: '#fff',
    width: '100%',
    padding: 10
  },
  containerPhone: {
    marginTop: '16px',
    marginBottom: '27px'
  },
  inputPhone: {
    '&:focus': {
      border: 'none !important',
      boxShadow: 'none !important'
    }
  },
  notificationIcon: {
    fill: '#4CAF50',
    marginLeft: 6
  },
  tawkToalert: {
    '& p, span': {
      margin: 0
    },
    '& strong': {
      fontWeight: 700
    }
  }
}))
export default class ChatsActions extends Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = { selectedProductChat: null, chat: null, viewedNewRelease: false };
  }

  onClose = () => {
    chatService.unselectProductChat();
    chatService.unselectChat();
  };

  onChangeType = (type: any) => {
    this.setState({ chat: { ...this.state.chat, type } });
    storageService
      .set('news_wpp', true)
      .subscribe(viewedNewRelease => this.setState({ viewedNewRelease: !viewedNewRelease }));
  };

  onChangeText = (cod: any) => {
    this.setState({ chat: { ...this.state.chat, key: cod } });
  };

  onChangeWpp = (phone: string) => {
    this.setState({ chat: { ...this.state.chat, key: phone } });
  };

  onChangeSwitch = () => {
    const { chat } = this.state;
    this.setState({ chat: { ...chat, active: !chat.active } });
  };

  componentDidMount() {
    chatService
      .getSelectedProductChat()
      .pipe(rxjsOperators.bindComponent(this))
      .subscribe(selectedProductChat => this.setState({ selectedProductChat }));

    chatService
      .getSelectedChat()
      .pipe(rxjsOperators.bindComponent(this))
      .subscribe(chat => this.setState({ chat }));

    storageService
      .get('news_wpp')
      .subscribe(viewedNewRelease => this.setState({ viewedNewRelease: !viewedNewRelease }));

    combineLatest([chatService.getSelectedChat(), productNewService.getSelectedProduct()])
      .pipe(
        rxjsOperators.map(([chat, selectedProduct]) => {
          return { selectedProduct, chat: !!chat };
        }),
        rxjsOperators.distinctUntilChanged((a, b) => JSON.stringify(a) === JSON.stringify(b)),
        rxjsOperators.filter(({ chat, selectedProduct }) => !!chat && !!selectedProduct)
      )
      .subscribe(() => analyticsG4.sendPageView({ feature: enFeatures.CHAT }));
  }

  submitChat = () => {
    const { chat, selectedProductChat } = this.state;
    if (!chat.type) {
      Snackbar.error('Escolha o Chat');
      return;
    }

    if (!chat.key) {
      Snackbar.error('Digite o ID');
      return;
    }

    chatService.setSelectedChat(chat);
    chatService.saveChat().subscribe(() => {
      Snackbar.show('Chat cadastrado com sucesso!');

      analyticsG4.sendSuccess(enFeatures.CHAT);

      productNewService.setSelectedProduct({
        ...selectedProductChat,
        chat: { active: chat.active }
      });

      productNewService.refreshProducts();
      this.onClose();
    });
  };

  render() {
    const { classes } = this.props;
    const chatText = {
      [enChat.JIVOCHAT]: 'JivoChat',
      [enChat.ZOPIMCHAT]: 'Zopim',
      [enChat.TAWKTOCHAT]: 'Tawk.to',
      [enChat.ZENDESKCHAT]: 'Zendesk',
      [enChat.LIVECHAT]: 'LiveChat',
      [enChat.CLICKDESK]: 'ClickDesk',
      [enChat.WHATSAPP]: 'Whatsapp',
      [enChat.WHATSAPPLINK]: 'Whatsapp Link'
    };
    const chatLabel = {
      [enChat.WHATSAPP]: 'Número',
      [enChat.WHATSAPPLINK]: 'URL',
      [enChat.TAWKTOCHAT]: 'Link direto do chat'
    };

    const { selectedProductChat, chat, viewedNewRelease } = this.state;
    const chatTypes = Object.keys(chatText);

    if (!selectedProductChat || !chat) {
      return null;
    }

    return (
      <Drawer
        anchor="right"
        open={!!selectedProductChat}
        ModalProps={{
          classes: { root: classes.removeBackdrop },
          disableBackdropClick: true,
          onBackdropClick: this.onClose
        }}
        PaperProps={{ classes: { root: classes.drawerPaper } }}
        transitionDuration={{ enter: 300, exit: 500 }}
      >
        <div className={classes.drawerOptions}>
          <div className={classes.titleClose}>
            <h2 className={classes.h2}>Ativando Chats</h2>
            <span className={classes.closeButton} onClick={this.onClose}>
              <SvgIcon name={'closeIcon'} />
            </span>
          </div>
          <ProductQuickView />
          <Grid container spacing={16} alignItems="center" justify="space-between">
            <Grid item xs={5}>
              <InputLabel className={classes.label}>Chat</InputLabel>
              <FieldSelect validation="required" value={chat.type || ''} onChange={this.onChangeType}>
                <MenuItem value="" disabled>
                  Selecione...
                </MenuItem>
                {chatTypes.map((chatName, i: number) => (
                  <MenuItem value={chatName} key={i}>
                    {chatName === enChat.WHATSAPP ? (
                      <Grid container item alignItems="center">
                        {chatText[chatName]}
                        {viewedNewRelease && <AlertCircleIcon size={20} className={classes.notificationIcon} />}
                      </Grid>
                    ) : (
                      chatText[chatName]
                    )}
                  </MenuItem>
                ))}
              </FieldSelect>
            </Grid>
            <Grid item xs={7}>
              <InputLabel className={classes.label}>{chatLabel[chat.type] ?? 'ID'}</InputLabel>
              {chat.type === enChat.WHATSAPP ? (
                <div className={classes.containerPhone}>
                  <PhoneInput
                    disableCountryGuess
                    specialLabel=""
                    country={'br'}
                    value={chat.key}
                    countryCodeEditable={false}
                    preferredCountries={['br', 'pt', 'us']}
                    onChange={this.onChangeWpp}
                  />
                </div>
              ) : (
                <FieldText validation="required" value={chat.key} onChange={this.onChangeText} />
              )}
            </Grid>
            {chat.type === enChat.TAWKTOCHAT && (
              <Grid item xs={12}>
                <PopUp
                  type="info"
                  message={
                    <div className={classes.tawkToalert}>
                      <span>
                        <strong>Fique Ligado!</strong>
                      </span>
                      <p>
                        Agora para adicionar o chat, você precisa ir até a opção <strong>Chat Widget</strong> e copiar o
                        campo <strong>&quot;Link direto do chat&quot;</strong>
                      </p>
                    </div>
                  }
                />
              </Grid>
            )}
            <Grid item xs={6} alignItems="center">
              <InputLabel className={classes.label}>Desativar/Ativar</InputLabel>
              <Switch onChange={this.onChangeSwitch} value={chat.active} checked={chat.active} disableRipple />
            </Grid>
            <Grid item xs={12}>
              <Button onClick={this.submitChat} className={classes.button}>
                Salvar
              </Button>
            </Grid>
          </Grid>
        </div>
      </Drawer>
    );
  }
}
